import './ListItem';
import NP from "../../NP";
import ListItem from "./ListItem";

export default class ListItemRadio extends ListItem {

	constructor(settings: object)
	{
		super(settings);
	}

	_render()
	{
		let cnt = this._Content || NP.RM.getString(this._RK) || '';
		cnt = `<span class="app-list-item__text">${cnt}</span>`;

		if (this._FontImage)
			this.np_render(`<li class="app-list-item">
<span class="app-list-item__graphic ${this._FontImage}"></span>${cnt}
${cnt}<span class="app-list-item__meta ${NP.FontImages.radiobutton_unchecked}"></span>
</li>`);
		else
			this.np_render(`<li class="app-list-item">
<span class="app-list-item__graphic ${NP.FontImages.radiobutton_unchecked}"></span>${cnt}
</li>`);

		if (this._Selected)
			this.setSelected(true);

		if (this._ShowDeleteButton)
			this.setShowDeleteButton(true);
	}

	setSelected(value: boolean)
	{
		this._Selected = value;
		let node = this._FontImage ? this._root.querySelector('.app-list-item__meta') : this._root.querySelector('.app-list-item__graphic');
		if (value)
		{
			NP.addCssClass(node, NP.FontImages.radiobutton_checked);
			NP.removeCssClass(node, NP.FontImages.radiobutton_unchecked);
		}
		else
		{
			NP.addCssClass(node, NP.FontImages.radiobutton_unchecked);
			NP.removeCssClass(node, NP.FontImages.radiobutton_checked);
		}
	}
};